'use client';

import { Check } from "lucide-react";
import { ChecklistItem } from "../static";
import { use, useEffect } from "react";

type ChecklistContentSectionProps = {
  content?: string;
  list?: ChecklistItem[] | string[];
  add_background?: boolean;
  add_bottom_border?: boolean;
};

export function ChecklistContentSection({ 
  content, 
  list,
  add_background = false,
  add_bottom_border = false
}: ChecklistContentSectionProps) {

  const contentElement = (
    <div className={`flex flex-col gap-4 ${add_bottom_border ? 'pb-8 border-b border-gray-200' : ''}`}>
      {content && (
        <div 
          className="text-pri font-normal text-[18px] [&_p]:mb-[18px]"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
      {list && list.length > 0 && (
        <ul className="list-none space-y-2">
          {list.map((item, i) => {
            // Handle both string[] and ChecklistItem[] formats
            const text = typeof item === 'string' ? item : item.text;
            return (
              <li key={i} className="flex items-start gap-2">
                <Check className="text-primary-300 text-xl shrink-0 mt-0.5" />
                <span className="text-gray-700">{text}</span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );

  if (add_background) {
    return (
      <div className="w-screen relative left-1/2 right-1/2 -mx-[10vw] bg-gradient-to-b from-[rgba(237,237,249,0)] to-[#DEE5E8] py-12">
        <div className="bg-[url('/images/left-corner-supergrafis.png')] bg-no-repeat bg-left-bottom bg-[length:300px]">
          <div className="container mx-auto max-w-7xl px-10">
            {contentElement}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto max-w-7xl">
      {contentElement}
    </div>
  );
}
